module.exports = __webpack_public_path__ + "img/itx-file-type-weba.682a7208.svg";